import { render, staticRenderFns } from "./PrescriptionForm.vue?vue&type=template&id=b82c6788&scoped=true"
import script from "./PrescriptionForm.vue?vue&type=script&lang=js"
export * from "./PrescriptionForm.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionForm.vue?vue&type=style&index=0&id=b82c6788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82c6788",
  null
  
)

export default component.exports